import React from "react";
import { Helmet } from "react-helmet";

const HeaderScripts = () => (
	<Helmet>
		<link
			rel="stylesheet"
			href="https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.11.4/jquery-ui.min.css"
			integrity="sha512-lvdq1fIyCp6HMWx1SVzXvGC4jqlX3e7Xm7aCBrhj5F1WdWoLe0dBzU0Sy10sheZYSkJpJcboMNO/4Qz1nJNxfA=="
			crossOrigin="anonymous"
			defer
		/>
		<link
			rel="stylesheet"
			href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap-daterangepicker/2.1.25/daterangepicker.min.css"
			integrity="sha512-cmVFpXGWYN65w88exhGdtVL0wsCGh5gZcmiPitIG4wEEzXCD8AnOjTSAZDQGOrBF4yRk9zLewQbt1O8jsp1K8g=="
			crossOrigin="anonymous"
			defer
		/>
	</Helmet>
);

export default HeaderScripts;
export { HeaderScripts };
